<p-datepicker
  [(ngModel)]="value"
  [disabled]="disabled"
  [minDate]="minDateStartOfDay"
  (onSelect)="dateSelected($event)"
  appendTo="body"
  [inputStyle]="inputStyle"
  [showButtonBar]="showButtonBar"
  [placeholder]="placeholder"
  [showClear]="showClear"
  [styleClass]="styleClass"
  [showIcon]="true"
  [autofocus]="false"
></p-datepicker>
